
import useReactiveZone from "reactive-zone";
import { Utils, DateUtil } from "../../utils/index.js";
import TaiBaseWidget from "../base.widget.js";
import template from './Time.template.html'


class TimeWidget extends TaiBaseWidget {

    zone = useReactiveZone(this);
    refInput = this.zone.useElementRef('ref.input')

    template() {
        return template
    }

    onZoneInit() {
        const { injectMethodToZone } = useReactiveZone(this);
        injectMethodToZone({
            onFocus: this.onFocus.bind(this)
        })
    }

    onRendered() {
        super.onRendered();

    }

    onFocus(e) {
        if (e.currentTarget.showPicker && !Utils.IsIFrame()) {
            // Iframe not allow to show picker
            try {
                e.currentTarget.showPicker();
            } catch (err) {

            }
        }
    }

    getValue() {
        const value = this.fieldModel.userResponse;
        if (value.length === 0) {
            return '';
        }
        const [hour, min] = value.split(':');
        const d = new Date();
        d.setHours(hour);
        d.setMinutes(min);
        return DateUtil.CaculateTimeZone(d.getTime());
    }
}

export default TimeWidget;